var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPositionIndicator = function SvgPositionIndicator(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 96,
    height: 96,
    viewBox: "0 0 96 96",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.5 48C8.5 26.1848 26.1848 8.5 48 8.5C69.8152 8.5 87.5 26.1848 87.5 48C87.5 69.8152 69.8152 87.5 48 87.5C26.1848 87.5 8.5 69.8152 8.5 48ZM36 27.9045C36 29.3566 36.6817 30.6262 37.7301 31.5215L54.6357 47.5401L37.9839 63.3181C36.8039 64.2135 36 65.5409 36 67.0911C36 69.8039 38.2989 72 41.1432 72C42.5676 72 43.8511 71.4432 44.7819 70.5523L65.5332 50.8721C66.4312 49.9945 67 48.8141 67 47.5C67 46.2037 66.4406 45.0455 65.5661 44.1725L44.8148 24.4923C43.884 23.5791 42.5864 23 41.1432 23C38.2989 23 36 25.1961 36 27.9045Z",
    fill: "white"
  })));
};
export default SvgPositionIndicator;